import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const CalendarContext = createContext({});

const CalendarProvider = ({ validateDates, children }) => (
  <CalendarContext.Provider value={{ validateDates }}>{children}</CalendarContext.Provider>
);

CalendarProvider.propTypes = {
  validateDates: PropTypes.func,
  children: PropTypes.node
};

export { CalendarContext, CalendarProvider };
